import { useCosmosEditorial } from 'providers/contexts/CosmosEditorialContext';
import { calculateEstimatedPrintDepth } from 'screens/editorial/asset/utility/editorUtilities';
import { GenericSearchItem } from '../../SearchItemsProvider';

type DepthFieldProps = {
  record: GenericSearchItem;
};

// Displays computed print depth using content_characters and site printDepthFactor
export default function DepthField({ record }: DepthFieldProps) {
  const { editorialConfig } = useCosmosEditorial();
  const recordType = record?.type;
  const contentCharacters = record?.content_characters;

  // Only show for articles
  if (recordType !== 'article') {
    return null;
  }

  // Validate print depth factor
  const factor = Number(editorialConfig?.asset_config?.article?.printDepthFactor);
  if (!factor || factor <= 0) {
    return null;
  }

  // Validate content_characters exists and is a valid integer
  if (contentCharacters == null || !Number.isInteger(contentCharacters)) {
    return null;
  }

  const depth = calculateEstimatedPrintDepth(contentCharacters, factor);
  return <span>{depth}</span>;
}
